import axios from 'axios';
import HttpStatus from './HttpStatus';
import Vue from 'vue';
// 创建axios实例并配置基本地址和超时时间
const service = axios.create({
    baseURL: process.env.VUE_APP_SERVE,  // 配置请求的基础URL
    timeout: 20000,  // 配置请求的超时时间，单位为毫秒，这里是20秒
});
// 请求拦截器
service.interceptors.request.use(function (config) {
    let access_token = localStorage.getItem("access_token");
    if (access_token) {
        config.headers['Authorization'] = `Bearer ${JSON.parse(access_token)}`;
    }
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});
// 在响应拦截器中，确保使用字符串类型的状态码进行比较
service.interceptors.response.use(
    function (result) {
        const { data } = result;
        // 判断是否为登录返回数据
        if (data && data.access_token) {
            // 处理登录成功的逻辑
            return data; // 返回数据，表示登录成功
        }
        // 使用字符串类型的状态码进行比较
        switch (data?.code) {
            case HttpStatus.SUCCESS:
            case HttpStatus.CREATED:
            case HttpStatus.ACCEPTED:
            case HttpStatus.NO_CONTENT:
            case HttpStatus.INTERNAL_SERVER_ERROR:
                return data;  // 请求成功，返回数据
            case HttpStatus.NOT_FOUND:
                return Promise.reject('资源未找到');
            case HttpStatus.BAD_REQUEST:
                return Promise.reject('请求参数错误');
            case HttpStatus.UNAUTHORIZED:
                window.location.href = process.env.VUE_APP_IP;  // 未授权，跳转到登录
                break;
            case HttpStatus.FORBIDDEN:
                window.location.href = process.env.VUE_APP_IP;  // 访问受限，跳转到登录
                break;
            case HttpStatus.NOT_IMPLEMENTED:
                return Promise.reject('接口未实现');
            default:
                return Promise.reject('未知错误');
        }
    },
    function (error) {
        // 处理响应错误，给出错误信息
        if (error.response) {
            const { status, data } = error.response;
            // 当状态是401 或者是403的时候跳转回登录页
            if (status === +HttpStatus.FORBIDDEN || status === +HttpStatus.UNAUTHORIZED) {
                Vue.prototype.$message.error(data?.error || '未授权访问');
                setTimeout(() => {
                    window.location.href = process.env.VUE_APP_IP + '/login';
                }, 2000);
            } else {
                Vue.prototype.$message.error(data?.error);
            }
        }
        return Promise.reject(error);
    }
);

export default service;
